import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth, startLogin } from "@/context/AuthContext";
import { Notice } from "@/components/Badges";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  useEffect(() => {
    if (user) navigate(user.mfa_pending ? "/mfa" : "/app", { replace: true });
  }, [user, navigate]);
  return (
    <div className="mx-auto max-w-md px-4 py-20">
      <div className="card p-8">
        <ShieldCheck className="h-8 w-8 text-[#0D9488]" aria-hidden />
        <h1 className="mt-4 text-2xl font-bold text-[#0B192C]">Sign in</h1>
        <p className="mt-2 text-sm text-slate-600">Individuals, unincorporated founders and businesses can all create an account. You can switch on authenticator-app MFA after signing in.</p>
        {params.get("error") && <div className="mt-4"><Notice tone="danger">Sign-in could not be completed. Please try again.</Notice></div>}
        <button onClick={startLogin} data-testid="google-signin-button" className="btn-teal mt-6 w-full">Continue with Google</button>
      </div>
    </div>
  );
}
